import { Layer3d } from "gis3d/cityvu/core/three/scene/Layer3d";
import { DataSource } from "gis3d/cityvu/data/DataSource";

export abstract class Layer3dBuilder<T extends Layer3d = Layer3d, O = any> {
    public abstract build(options: O, dataSource: DataSource): T;
}
